import { Component, OnInit } from '@angular/core';
import $ from 'jquery';
import { CacheService } from 'src/appv2/services/cache.service';
import { CmsPageService } from 'src/appv2/services/cms-page.service';
import { LandingPageService } from 'src/appv2/services/landing-page.service';
import { urlToCacheKeyMapping } from 'src/appv2/utils/constants/discount.const';

@Component({
  selector: 'appv2-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss'],
})
export class TermsAndConditionsComponent implements OnInit {
  constructor(
    private cmsPage: CmsPageService,
    private landingPage: LandingPageService,
    private cacheService: CacheService
  ) {
    this.termsCacheKey = urlToCacheKeyMapping[this.termsCacheKeyName];
    if (this.termsCacheKey) {
      const loadData = this.cacheService.getData(this.termsCacheKey);
      if (typeof loadData !== 'undefined') {
        this.pageData = loadData;
      } else {
        this.getCmsPage(this.page);
      }
    }
  }

  page: string = 'terms-and-conditions';

  pageData: any;
  termsCacheKeyName: string = 'cms-page-terms-and-agreement';
  termsCacheKey: string;

  ngOnInit(): void {
    $('html, body').animate({ scrollTop: '0' }, 800);
    this.getCmsPage(this.page);
  }

  getCmsPage(page) {
    this.cmsPage.getpagelist(page).subscribe((data) => {
      this.pageData = data.data;
      this.cacheService.setData(this.termsCacheKey, this.pageData);
      this.landingPage.isCmsPageTermsAgreementCalled.next(true);
    });
  }
}
